import 'reflect-metadata'
import { instanceToPlain } from 'class-transformer'

export abstract class Entity<TInterface> {
  public toPlain(): TInterface {
    return instanceToPlain(this) as TInterface
  }
}
